export const rowBase =
  "cursor-pointer border-b border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors";

export const selectedRow =
  "bg-indigo-50/80 dark:bg-indigo-950/30 shadow-[inset_3px_0_0_rgb(79_70_229)] hover:bg-indigo-50 dark:hover:bg-indigo-950/40";
